<template>
  <div class="page">
    <div class="head">
        学生管理
    </div>
    <div class="content">
        <div class="bar">
            <span class="bartip">学号:</span>
             <el-input style="width:10%" clearable v-model="query.keyword" placeholder="请输入学号或姓名"></el-input>
            <span class="bartip">站点:</span>
            <el-select style="width:12%" v-model="query.siteId" clearable placeholder="请选择" @change="changeSite" >
                <el-option
                v-for="item in sites"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
            <span class="bartip">单位:</span>
            <el-select style="width:12%" v-model="query.unitId" clearable filterable placeholder="请选择">
                <el-option
                v-for="item in units"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
            <span class="bartip">专业:</span>
            <el-select style="width:8%" v-model="query.majorId" clearable placeholder="请选择">
                <el-option
                v-for="item in majors"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
            <span class="bartip">案例:</span>
            <el-select style="width:8%" v-model="query.courseId" clearable placeholder="请选择">
                <el-option
                v-for="item in courses"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
            <span class="bartip">实验批次:</span>
            <el-select style="width:8%" v-model="query.expBatchId" clearable placeholder="请选择">
                <el-option
                v-for="item in expbatches"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
            
            <el-button  class="bartip"  @click="toSearch" size="small" type="primary" round>搜索</el-button>
        </div>
        <div class="table" >
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
                align="center"
                />
                <el-table-column
                    prop="code"
                    label="学号">
                </el-table-column>
                <el-table-column
                    prop="displayName"
                    label="姓名">
                </el-table-column>
                 <el-table-column
                    prop="course"
                    label="案例名称">
                </el-table-column>
                <el-table-column
                    prop="level"
                    label="层次">
                </el-table-column>
                <el-table-column
                    prop="major"
                    label="专业">
                </el-table-column>
                <el-table-column
                    prop="enrollBatch"
                    label="入学批次">
                </el-table-column>
                <el-table-column
                    prop="expBatch"
                    label="实验批次">
                </el-table-column>
                <el-table-column
                    prop="site"
                    label="站点">
                </el-table-column>
                 <el-table-column
                    prop="unit"
                    label="单位">
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
            <el-pagination
            @current-change="handleCurrentChange"
            :current-page="query.currentPage"
            :page-size="query.size"
            layout="total, prev, pager, next, jumper"
            :total="query.total"
            />
        
    </div>
  </div>
</template>

<script>
import ajaxObj from "@/ajax";
export default {
    inject: ['reload'],
 data(){
     return {
        searchInput:'',
        tableData:[],
        query: {
        currentPage: 1,
        size: 10,
        page:0,
        total: 0,
        keyword:'',
        roleName:'',
        unitId:""
        },
        // 添加 表单
        visible:false,
        visible2:false,
        title:'添加学生信息',
        title2:'修改学生信息',
        form: {},
        form2:{},
        rules: {
            code: [
            { required: true, message: '请输入学号/工号', trigger: 'blur' }
            ],
            name: [
            { required: true, message: '请输入学生名', trigger: 'blur' }
            ],
            password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
            ],
            displayName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            roleId: [
            { required: true, message: '请输入roleId', trigger: 'blur' }
            ]
        },
        // 搜索
        sites:[],
        levels:[],
        majors:[],
        courses:[],
        expbatches:[],
        enrollbatches:[],
        units:[]
    }
 },
 methods:{
     findUserlist(){
        ajaxObj({url: "users/student",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            console.log(this.tableData);
            this.query.total = response.data.meta.total;
        })
     },
     changeSite(){
        this.units=[];
        // this.query.unitId = "";
        this.$set(this.query, 'unitId', '')

        ajaxObj({url: "users/units",method: "get",params:this.query})
        .then(response => {
            this.units = response.data.data;
        })


        //console.log()
        //alert(this.query.siteId == '')

    },
      // 序号
    indexMethod(index){
       index = index + 1 + (this.query.currentPage - 1) * this.query.size;
      return index;
    },
    //  搜索
    // 1. site查询
    findSites(){
        ajaxObj({url: "users/all-site",method: "get"})
            .then(response => {
                this.sites = response.data.data;
            })
    },
    // 2. level查询
    findLevels(){
        ajaxObj({url: "users/all-level",method: "get"})
            .then(response => {
                this.levels = response.data.data;
            })
    },
    // 3. major查询
    findMajors(){
        ajaxObj({url: "users/all-major",method: "get"})
            .then(response => {
                this.majors = response.data.data;
                console.log('majors',this.majors);
            })
    },
    // 4. expbatch查询
    findExpbatches(){
        ajaxObj({url: "users/all-expbatch",method: "get"})
            .then(response => {
                this.expbatches = response.data.data;
            })
    },
    // 5. course查询
    findCourses(){
        ajaxObj({url: "courses/all",method: "get"})
            .then(response => {
                this.courses = response.data.data;
            })
    }, 
    // 5. enrollbatch查询
    findEnrollbatches(){
        ajaxObj({url: "users/all-enrollbatch",method: "get"})
            .then(response => {
                this.enrollbatches = response.data.data;
            })
    }, 
    //  搜索
     toSearch(){
        this.query.currentPage = 1;
        this.query.page = this.query.currentPage -1;
        ajaxObj({url: "users/student",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
     },
    
     
     // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
    this.pagesize = size
    console.log(this.pagesize) // 每页下拉显示数据
    },
    handleCurrentChange: function(page) {
    this.query.currentPage = page;
    this.query.page = page-1;
    this.currentPage = page
    console.log(this.currentPage) // 点击第几页
        ajaxObj({url: "users/student",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
    },

 },
 created(){
    this.findUserlist();
    this.findSites();
    this.findLevels();
    this.findMajors();
    this.findExpbatches();
    this.findEnrollbatches();
    this.findCourses();
 }
}
</script>

<style scoped>
.page {
    width: 100%;
    height: 100%;
}
.head {
    padding: 20px;
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    box-sizing:border-box;

}
.bar {
    height: 100px;
    box-sizing:border-box;
    padding: 20px;
    font-size: 18px;
    padding-left: 60px;
    display:flex;
    align-items:center;
}
.bartip {
    margin: 0 8px 0 8px;
}
.table {
    width:98%;
    margin:0 auto;
}
.el-pagination {
    text-align: right;
    box-sizing: border-box;
    padding-right: 100px;
    padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/teach/student.vue